import { ApiCore } from '@/services/api/utils/core.js';
const url = 'v1/renew-token';
const api = new ApiCore({ 
  url,
  create: true
});
export default api;